<div class="report-container">
  @if (isLoading) {
    <div>
      <img src="assets/images/loader.gif">
    </div>
  }
  @if (reportUrl && !isLoading) {
    <iframe [src]="reportUrl" width="100%" height="100%"></iframe>
  }
  <ng-template #errorMessage>
    @if (!isLoading && !reportUrl) {
      <div>
        <h3>{{ 'Report not available' | translate }}</h3>
        <p>{{ 'There was an error generating the report. Please try again later.' | translate }}</p>
      </div>
    }
  </ng-template>
</div>